var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PublicNavbar'),_c('div',{staticClass:"container mt-5"},[_vm._t("default")],2),_c('SizedBox',{attrs:{"height":"150"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }